/**
 * Copy plain text to the clipboard (web + native).
 * Same platform split as `copyRequestLinkToClipboard`; does not toast or log the value.
 */
import Clipboard from '@react-native-clipboard/clipboard';
import { Platform } from 'react-native';

/** Displayed empty delta in Revision History (`formatDeltaValue`). */
export const EMPTY_DELTA_DISPLAY = '—';

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  if (!text || text === EMPTY_DELTA_DISPLAY) {
    return false;
  }

  try {
    if (
      Platform.OS === 'web' &&
      navigator.clipboard &&
      window.isSecureContext
    ) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    if (Platform.OS === 'web') {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      return successful;
    }
    Clipboard.setString(text);
    return true;
  } catch {
    return false;
  }
};
